import formModel from './formModel';

const {
    propertyLocation,
    postalCode,
    gpsCoordinates,
    sumInsredAmount,
    propertyQuestion1,
    insured,
    buildingOccupation,
    roofConstruction,
    wallConstruction,
    contactPerson,
    contactNumber,
    email,
    yourBroker,
    preferredBranch,
} = formModel;

const initialValues = {
    [propertyLocation.name]: '',
    [postalCode.name]: '',
    [gpsCoordinates.name]: '',
    [sumInsredAmount.name]: '2500000',
    [propertyQuestion1.name]: '',
    [insured.name]: '',
    [buildingOccupation.name]: '',
    [roofConstruction.name]: 'Standard (Tiles / IBR / Concrete)',
    [wallConstruction.name]: 'Standard (Brick / Concrete)',
    [contactPerson.name]: '',
    [contactNumber.name]: '',
    [email.name]: '',
    [yourBroker.name]: '',
    [preferredBranch.name]: 'Johannesburg',
};

export default initialValues;
